import TemplateDropdown from "src/components/template/template-dropdown";
import * as React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useTeamSprints } from "src/scenes/teams/dashboard/selected-sprints-provider-teams";
import { useSprints } from "src/scenes/dashboard/selected-sprint-provider";
import { useEffect, useState } from "react";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";

const JiraProjectSelector = ({ queryVariablesSetter, value, setValue }) => {
    const { teamId } = useParams();
    const [searchParams] = useSearchParams();
    const [projects, setProjects] = useState<{ projectKey: string; default?: boolean }[]>();
    const useSprint = teamId ? useTeamSprints() : useSprints();
    const { isDemo, userHasTeamsSubscription } = useAuth();

    const getSprints = async (id) => {
        if (id)
            if (userHasTeamsSubscription) {
                if (
                    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
                        id
                    )
                ) {
                    const res = await request<{
                        projects: { projectKey: string; default?: boolean }[];
                    }>(`/api/data/fundamentals/teams/${id}/v1/jira-projects`, {
                        method: "GET",
                    });
                    setProjects(res.projects);
                } else {
                    const res = await request<{
                        projects: { projectKey: string; default?: boolean }[];
                    }>(`/api/data/fundamentals/v1/jira-projects`, {
                        method: "GET",
                    });
                    setProjects(res.projects);
                }
            }
        if (isDemo || !userHasTeamsSubscription) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const res = await import(
                "../../scenes/dashboard/mock-data/work-fundamentals/jira-projects"
            );
            setProjects(res.default);
        }
    };

    useEffect(() => {
        if (teamId) setProjects(useSprint?.allProjects?.projects || undefined);
        if (searchParams.get("selectedTeam")) getSprints(searchParams.get("selectedTeam"));
    }, [teamId, searchParams.get("selectedTeam"), useSprint]);

    if (!queryVariablesSetter || !queryVariablesSetter.project) return null;
    if (!projects || !projects.length) return null;
    return (
        <TemplateDropdown
            options={null}
            title="Jira Project"
            allValue="All"
            dynamicOptions={queryVariablesSetter.project.dynamicOptions}
            value={value}
            setValue={setValue}
            data={{ projects }}
        />
    );
};

export default JiraProjectSelector;
